import { Box, Container } from "@mui/material";
import { Outlet } from "react-router";
import Header from "../../../common/layouts/Header/Header";
import Sidebar from "./Sidebar";

function AdminLayout() {
  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <Sidebar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minWidth: 0,
        }}
      >
        <Header />
        <Box
          id="main-scroll-container"
          sx={{
            flex: 1,
            overflow: "auto",
            backgroundColor: "background.default",
          }}
        >
          <Container
            sx={{
              px: { xs: 2, sm: 4, md: 8 },
              py: 6,
              maxWidth: "none !important",
            }}
          >
            <Outlet />
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default AdminLayout;
